import { render, staticRenderFns } from "./OtomoCanvas.vue?vue&type=template&id=09d44122&"
import script from "./OtomoCanvas.vue?vue&type=script&lang=ts&"
export * from "./OtomoCanvas.vue?vue&type=script&lang=ts&"
import style0 from "./OtomoCanvas.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports